import { request } from "../../utils/AxiosInstance";

export const PendingSahajCoordinatorApi = async (params) => {
  const email = params.queryKey[1];
  return request({
    url: `pending_sahaj_coordinator/${email}`,
  });
};